import { evaluateFormular } from '@/actions/customFilter';
import { useAppSelector } from '@/hooks';
import { useMemoStateFromFilterDeps } from '@/lib/useMemoStateFromFilterDeps';

export const useHideFilterResults = () => {
  const hideFilter = useAppSelector((state) => state.ensfields.ens_hide_frontend_filterbox);
  const state = useMemoStateFromFilterDeps(hideFilter);
  return evaluateFormular(hideFilter, state.userData, state, null, false);
};
